import React from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const CompetitionRow = (props) => {
  const { itemIndex, result, match } = props;

  return (
    <tr key={itemIndex}>
      <td>
        <Link
          to={"/organizations/" + match.params.organizationId + "/competitions/" + result.competitionId + "/seasons"}
          className="link"
          title="Seasons"
        >
          {result.nameLocal}
        </Link>
      </td>
      <td>
        <Link
          to={"/organizations/" + match.params.organizationId + "/competitions/" + result.competitionId + "/seasons"}
          className="link"
          title="Seasons"
        >
          {result.nameLatin}
        </Link>
      </td>
      <td className="text-right controls-3">
        <Link
          to={"/organizations/" + match.params.organizationId + "/competitions/" + result.competitionId + "/seasons"}
          title="Seasons"
          className="btn btn-outline-secondary btn-sm btn-action"
        >
          <FormattedMessage id="seasons" defaultMessage="Seasons" description="Seasons" />
          <i className="fas fa-chevron-right" />
        </Link>
      </td>
    </tr>
  );
};

export default CompetitionRow;
